import Vue from 'vue'
import Vuex from 'vuex'

import session from './idonia-api/session'
import accounts from './idonia-api/accounts/accounts'
import account from './idonia-api/accounts/account'
import actionsTray from './idonia-api/files/actionsTray'
import filters from '~/store/idonia-api/files/filters'
import contracts from './idonia-api/contracts'
import group from './idonia-api/groups/group'
import groups from './idonia-api/groups/groups'
import groupsAccount from './idonia-api/groups/groupsAccount'
import directory from './idonia-api/directory/directory'
import study from './idonia-api/study/study'
import containers from './idonia-api/containers/containers'
import files from './idonia-api/files/files'
import file from './idonia-api/files/file'
import parentChild from './idonia-api/files/parentChild'
import directoryChildren from './idonia-api/directory/children'
import recents from './idonia-api/files/recents/recents'
import starred from './idonia-api/files/starred/starred'
import trash from './idonia-api/files/trash/trash'
import trashCount from './idonia-api/files/trash/count'
import sharers from './idonia-api/sharers/sharers'
import sharer from './idonia-api/sharers/sharer'
import search from './idonia-api/search/search'
import document from './idonia-api/documents/document'
import shareFile from './idonia-api/share/shareFile'
import notifications from './idonia-api/notifications/notifications'
import dialog from './idonia-api/dialog'
import download from './idonia-api/files/download/download'
import tags from './idonia-api/tags/tags'
import tag from './idonia-api/tags/tag'
import fileTag from './idonia-api/files/fileTag'
import fileColors from './idonia-api/colors/colors'
import fileColor from './idonia-api/colors/color'
import feedback from './idonia-api/feedback'
import compare from './idonia-api/compare'
import viewport from './viewport'
import filesFeedback from './idonia-api/files/feedback/feedback'
import tasks from './idonia-api/tasks/tasks'
import bus from '~/bus.js'
Vue.use(Vuex)

let nav = {
  namespaced: true,
  state: {
    adminPanel: false,
    fullView: false,
    drawerRight: false,
    rightDrawerProps: {
      title: '',
      elements: []
    },
    navRoot: {},
    navPath: [],
    navCurrent: {},
    showTitle: false,
    preferredTab: 'tests',
    hidePolicy: false,
    hideTerms: false,
    hideFooter: false,
    hideFooterOnViewer: false,
    iosFullscreen: false

  },
  getters: {
    hidePolicy: state => {
      return state.hidePolicy
    },
    hideTerms: state => {
      return state.hideTerms
    },
    hideFooter: state => {
      return state.hideFooter
    },
    hideFooterOnViewer: state => {
      return state.hideFooterOnViewer
    },
    iosFullscreen: state => {
      return state.iosFullscreen
    }
  },
  mutations: {
    adminPanel (state, adminPanel) {
      state.adminPanel = adminPanel
    },
    fullView (state, fullView) {
      state.fullView = fullView
    },
    drawerRight (state, drawerRight) {
      state.drawerRight = drawerRight
    },
    rightDrawerTitle (state, title) {
      state.rightDrawerProps.title = title
    },
    rightDrawerElements (state, elements) {
      state.rightDrawerProps.elements = elements
    },
    navElements (state, navElements) {
      state.navRoot = navElements.root
      state.navPath = navElements.path
      state.navCurrent = navElements.current
    },
    clearNavElements (state) {
      state.navRoot = {}
      state.navPath = []
      state.navCurrent = {}
    },
    navRoot (state, root) {
      state.navRoot = root
    },
    navPath (state, path) {
      state.navPath = path
    },
    addNavPath (state, path) {
      state.navCurrent.push(path)
    },
    navCurrent (state, current) {
      state.navCurrent = current
    },
    showTitle (state, showTitle) {
      state.showTitle = showTitle
    },
    preferredTab (state, preferredTab) {
      state.preferredTab = preferredTab
    },
    setHidePolicy (state, policy) {
      state.hidePolicy = policy
    },
    setHideTerms (state, terms) {
      state.hideTerms = terms
    },
    setHideFooter (state, terms) {
      state.hideFooter = terms
    },
    setHideFooterOnViewer (state, hide) {
      state.hideFooterOnViewer = hide
    },
    setFullScreen (state, val) {
      state.iosFullscreen = val
    }
  },
  actions: {
    adminPanel ({commit}, adminPanel) {
      commit('adminPanel', adminPanel)
    },
    fullView ({commit}, fullView) {
      commit('fullView', fullView)
    },
    drawerRight ({commit}, drawerRight) {
      commit('drawerRight', drawerRight)
      commit('rightDrawerTitle', '')
      commit('rightDrawerElements', [])
    },
    rightDrawerTitle ({ commit }, title) {
      commit('rightDrawerTitle', title)
    },
    rightDrawerWithProps ({commit}, { open, props }) {
      commit('drawerRight', open)
      if (open && props.title) {
        commit('rightDrawerTitle', props.title)
      }
      if (open && props.elements) {
        commit('rightDrawerElements', props.elements)
      }
    },
    navElements ({commit}, navElements) {
      commit('navElements', navElements)
    },
    clearNavElements ({commit}) {
      commit('clearNavElements')
    },
    navRoot ({commit}, root) {
      commit('navRoot', root)
    },
    navPath ({commit}, path) {
      commit('navPath', path)
      bus.$emit('navPathLoaded', path)
    },
    addNavPath ({commit}, path) {
      commit('addNavPath', path)
    },
    navCurrent ({commit}, current) {
      commit('navCurrent', current)
    },
    showTitle ({commit}, showTitle) {
      commit('showTitle', showTitle)
    },
    preferredTab ({commit}, preferredTab) {
      commit('preferredTab', preferredTab)
    },
    hidePolicy ({commit}, policy) {
      commit('setHidePolicy', policy)
    },
    hideTerms ({commit}, terms) {
      commit('setHideTerms', terms)
    },
    hideFooter ({commit}, terms) {
      commit('setHideFooter', terms)
    },
    hideFooterOnViewer ({commit}, hide) {
      commit('setHideFooterOnViewer', hide)
    },
    fullScreen ({commit}, val) {
      commit('setFullScreen', val)
    }
  }
}

let dragging = {
  namespaced: true,
  state: {
    from: {},
    to: {}
  },
  mutations: {
    setFrom (state, from) {
      state.from = from
    },
    setTo (state, to) {
      state.to = to
    },
    clear (state) {
      state.from = {}
      state.to = {}
    }
  },
  actions: {
    setFrom ({commit}, from) {
      commit('setFrom', from)
    },
    setTo ({commit}, from) {
      commit('setTo', from)
    },
    clear ({commit}) {
      commit('clear')
    }
  }
}

let color = {
  namespaced: true,
  state: {
    directories: {
      s: 67,
      v: 92,
      hues: [
        {h: 0, name: 'Red'},
        {h: 20, name: 'Dark Orange'},
        {h: 40, name: 'Light Orange'},
        {h: 60, name: 'Yellow'},
        {h: 80, name: 'Lime'},
        {h: 100, name: 'Green'},
        {h: 120, name: 'Dark Green'},
        {h: 140, name: 'Light Green'},
        {h: 160, name: 'Aquamarine'},
        {h: 180, name: 'Cyan'},
        {h: 200, name: 'Light Blue'},
        {h: 220, name: 'Blue'},
        {h: 240, name: 'Dark Blue'}
      ]
    },
    documents: {
      s: 92,
      v: 40
    },
    filters: []
  },
  mutations: {
    setDirectoriesHues (state, hues) {
      state.directories.hues = hues
    },
    setDirectoriesS (state, s) {
      state.directories.s = s
    },
    setDirectoriesV (state, v) {
      state.directories.v = v
    },
    setDocumentsS (state, s) {
      state.documents.s = s
    },
    setDocumentsV (state, v) {
      state.documents.v = v
    },
    setFilters (state, filters) {
      state.filters = filters
    }
  },
  actions: {
    setDirectoriesHues ({commit}, hues) {
      commit('setDirectoriesHues', hues)
    },
    setDirectoriesS ({commit}, s) {
      commit('setDirectoriesS', s)
    },
    setDirectoriesV ({commit}, v) {
      commit('setDirectoriesV', v)
    },
    setDocumentsS ({commit}, s) {
      commit('setDocumentsS', s)
    },
    setDocumentsV ({commit}, v) {
      commit('setDocumentsV', v)
    },
    setFilters ({commit}, filters) {
      commit('setFilters', filters)
    }
  }
}

const config = {
  namespaced: true,
  state: {
    globalSearch: true,
    whatsappFiles: true,
    notifications: true,
    myspace: true,
    mio: false,
    defaultLanding: '/myspace',
    premium: false,
    tags: false,
    orderBy: true,
    info: true,
    myspacelimit: true,
    oauth2: false,
    oauth2providers: {
      google: false
    },
    enableMLPassword: true
  },
  getters: {
    restrictProViewer: () => Vue.prototype.$whitelabel.viewerConfig.restrict_pro_viewer
  }
}

let infoTabs = {
  namespaced: true,
  state: {
    index: 0
  },
  mutations: {
    setIndex (state, index) {
      state.index = index
    },
    clear (state) {
      state.from = 0
    }
  },
  actions: {
    setIndex ({commit}, index) {
      commit('setIndex', index)
    },
    clear ({commit}) {
      commit('clear')
    }
  }
}

export default new Vuex.Store({
  modules: {
    account,
    accounts,
    actionsTray,
    color,
    config,
    containers,
    contracts,
    dialog,
    download,
    directory,
    directoryChildren,
    document,
    dragging,
    feedback,
    file,
    fileColor,
    fileColors,
    fileTag,
    files,
    filesFeedback,
    filters,
    group,
    groups,
    groupsAccount,
    infoTabs,
    nav,
    notifications,
    parentChild,
    recents,
    session,
    shareFile,
    sharer,
    sharers,
    starred,
    study,
    search,
    tag,
    tags,
    tasks,
    trash,
    trashCount,
    viewport,
    compare
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js